// extracted by mini-css-extract-plugin
module.exports = {"declaration":"REh3973TQCfwXc9Ceo2gJg==","footer":"_1FfDk0FG2+-Y+Wms6wNuJQ=="};